export enum DataGridFilterExpressionPartTypeEnum {
    Condition,
    Operator
}